import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import "react-quill/dist/quill.snow.css";
import DatePicker from "react-datepicker";
import { FaCalendarAlt } from "react-icons/fa";
import Switch from "react-switch";

const ListLogisticsFilters = ({
  formConfig,
  formData,
  setFormData,
  validationErrors = {},
  setValidationErrors = {},
  showParentDesignation,
  setShowParentDesignation = () => {},
  images,
  buttonOnclick,
  setIsMultipleCities,
  setCities,
  cities,
  fieldsdisabled,
  handleSearch,
  handleClear,
  setSelectedPage,
  setModalIsOpen,
}) => {
  const [fileNames, setFileNames] = useState({});

  const [pincode, setPincode] = useState("");

  const [isInitial, setIsInitial] = useState(true);

  const [selectedDate, setSelectedDate] = useState(null);
  const today = new Date();

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const token = localStorage.getItem("authToken");
  const user_type = localStorage.getItem("UserType");
  const datePickerRefs = useRef({});

  // const handleChange = (name, value, type) => {
  //   if (type === "checkbox" || type === "toggle") {
  //     if (name === "buyback" && value === true) {
  //       console.log("name>>", name, value);
  //       setShowParentDesignation(true);
  //     } else {
  //       setShowParentDesignation(false);
  //     }
  //     setFormData({ ...formData, [name]: value });
  //     console.log("formdata???", formData);
  //   } else if (type === "file") {
  //     setFormData({ ...formData, [name]: value });
  //     setFileNames({ ...fileNames, [name]: value.name });
  //   } else {
  //     setFormData({ ...formData, [name]: value });
  //   }

  //   // Additional logic for pincode field
  //   if (name === "pincode") {
  //     setPincode(value);
  //   }

  //   // Validate the field after change
  //   validateField(name, value);
  // };

  const handleChange = (name, value, type) => {
    if (type === "checkbox" || type === "toggle") {
      if (name === "buyback" && value === true) {
        console.log("name>>", name, value);
        setShowParentDesignation(true);
      } else {
        setShowParentDesignation(false);
      }
      setFormData({ ...formData, [name]: value });
      console.log("formdata???", formData);
    } else if (type === "file") {
      setFormData({ ...formData, [name]: value });
      setFileNames({ ...fileNames, [name]: value.name });
    } else {
      setFormData({ ...formData, [name]: value });
    }

    // Handle Page No. selection
    if (name === "number_id") {
      console.log("value", value);
      setSelectedPage(value);
      setModalIsOpen(true); // Open the modal when a page is selected
    }

    // Handle pincode field separately
    if (name === "pincode") {
      setPincode(value);
    }

    // Validate the field after change
    validateField(name, value);
  };

  const validateField = (name, value) => {
    console.log("name", name, value);

    const fieldConfig = formConfig?.find((field) => field.name === name);
    console.log("formConfig", formConfig);

    if (fieldConfig && fieldConfig?.validation) {
      const { required, minLength, maxLength, pattern, message } =
        fieldConfig.validation;
      let error = "";

      if (required && (value === undefined || value === null || value === "")) {
        console.log("value", value);
        error = "This field is required*";
      } else if (minLength && value.length < minLength) {
        error = `Minimum length ${minLength} characters`;
      } else if (maxLength && value.length > maxLength) {
        error = `Maximum length ${maxLength} characters`;
      } else if (pattern && !pattern.test(value)) {
        error = `${message}`;
      }

      if (name === "endDate" && formData.startDate && value) {
        const startDate = new Date(formData.startDate);
        const endDate = new Date(value);
        if (endDate < startDate) {
          error = "To Date cannot be earlier than From Date.";
        }
      }

      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [name]: error,
      }));
    }
  };

  const handleDropdownChange = (name, selectedOption) => {
    console.log("selected options", name, selectedOption);

    if (name === "productName") {
      setFormData({
        ...formData,
        [name]: selectedOption.value,
        subproductName: null,
        makeName: null,
      });
    } else if (name === "city") {
      const selectedCity = cities?.find(
        (city) => city.city_id === selectedOption.value
      );
      setFormData((prevData) => ({
        ...prevData,
        [name]: selectedOption.label,
        city_id: selectedOption?.value,
        state: selectedCity.state_name,
        state_id: selectedCity.state_id,
        country: selectedCity.country_name,
        country_id: selectedCity.country_id,
      }));
    } else {
      setFormData({ ...formData, [name]: selectedOption?.value });
    }
    validateField(name, selectedOption ? selectedOption?.value : null);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderColor: "#ccc",
      boxShadow: "none",
      borderRadius: "10px",
      "&:hover": {
        borderColor: "#888",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      height: "50px",
      width: "200px",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "5px",
      borderColor: "#ccc",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#7BD755"
        : state.isFocused
        ? "#fff"
        : null,
      // color: state.isSelected || state.isFocused ? "white" : "black",
      "&:hover": {
        backgroundColor: "#f2fcf0",
        color: "#000",
      },
    }),
  };

  const renderField = (field) => {
    const additionalClass = field.gridClass ? ` ${field.gridClass}` : "";
    switch (field.type) {
      case "text":
      case "email":
      case "number":
        return (
          <div key={field?.name} className="mt-2 mb-2">
            <label>
              {field?.label}{" "}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <input
              type={field?.type}
              name={field?.name}
              value={formData[field?.name] || ""}
              placeholder={field?.placeholder || ""}
              disabled={field?.disabled}
              // minLength={2}
              maxLength={field?.validation && field?.validation?.maxLength}
              onChange={(e) =>
                handleChange(field.name, e.target.value, field.type)
              }
              className={`form-control ${
                validationErrors[field?.name] && "is-invalid"
              }`}
            />
            {validationErrors[field?.name] && (
              <div className="invalid-feedback">
                {validationErrors[field?.name]}
              </div>
            )}
          </div>
        );

      case "dropdown":
        return (
          <div key={field.name} className="mt-2 mb-2">
            <label>
              {field?.label}
              {field?.required && <span className="required-asterisk">*</span>}
            </label>
            <Select
              isClearable
              key={field.name}
              name={field.name}
              isDisabled={field?.disabled}
              options={field?.options}
              styles={customStyles}
              defaultValue={formData[field.name] || field.defaultValue}
              value={
                field?.options?.find(
                  (option) => option?.value === formData[field?.name]
                ) || null
              }
              onChange={(selectedOption) =>
                handleDropdownChange(field?.name, selectedOption)
              }
              menuPlacement={field?.dropdownOptionsListPosition || "auto"}
            />
            {validationErrors[field.name] && (
              <div className="customerror">{validationErrors[field.name]}</div>
            )}
          </div>
        );

      case "button":
        return (
          <div className=" mt-1 mb-2">
            <label>{""}</label>
            <div className="downloadiconwrapper " onClick={buttonOnclick}>
              <label>{field.label}</label>
            </div>
          </div>
        );
      case "date":
        const openDatePicker = (fieldName) => {
          if (datePickerRefs.current[fieldName]) {
            datePickerRefs.current[fieldName].setFocus();
          }
        };

        return (
          <div key={field?.name} className="mt-2 mb-2">
            <label>
              {field.label}{" "}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <div className="input-group">
              <DatePicker
                ref={(ref) => (datePickerRefs.current[field.name] = ref)}
                placeholderText="DD/MM/YYYY"
                disabled={field?.disabled ? true : false}
                selected={
                  formData[field?.name] ? new Date(formData[field.name]) : null
                }
                onChange={(date) => handleChange(field.name, date, "date")}
                minDate={field?.minDate}
                maxDate={field?.maxDate}
                // dateFormat="yyyy-MM-dd"
                dateFormat="dd/MM/yyyy"
                className={`form-control ${
                  validationErrors[field.name] && "is-invalid"
                }`}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
              />
              <span
                className="input-group-text"
                onClick={() => openDatePicker(field.name)}
                style={{ cursor: "pointer" }}
              >
                <FaCalendarAlt />
              </span>
            </div>
            {validationErrors[field.name] && (
              <div className="invalid-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );
      case "datetime":
        return (
          <div key={field.name} className="form-group mt-2 mb-2">
            <label>
              {field.label}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <div className="input-group">
              <DatePicker
                ref={datePickerRefs}
                disabled={field?.disabled ? true : false}
                selected={
                  formData[field.name] ? new Date(formData[field.name]) : null
                }
                onChange={(date) => handleChange(field.name, date, "datetime")}
                showTimeSelect
                dateFormat="Pp"
                maxDate={field.maxDate}
                minDate={field.minDate}
                className={`form-control ${
                  validationErrors[field.name] && "is-invalid"
                }`}
              />
              <div className="input-group-append">
                <span
                  className="input-group-text"
                  onClick={() => datePickerRefs.current.setFocus()}
                >
                  <FaCalendarAlt />
                </span>
              </div>
            </div>
            {validationErrors[field.name] && (
              <div className="invalid-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );
      case "toggle":
        return (
          <div
            key={field?.name}
            className={`${additionalClass} mt-3 mb-3 togglecontainer`}
          >
            <Switch
              checked={formData[field?.name] || false}
              onChange={(checked) =>
                handleChange(field?.name, checked, "toggle")
              }
              onColor="#7BD755"
              onHandleColor="#7BD755"
              handleDiameter={30}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              height={20}
              width={48}
              className="react-switch"
              id="material-switch"
              disabled={field?.disabled ? true : false}
            />
            <label className="mt-3 mb-3">{field.label}</label>
            {validationErrors[field?.name] && (
              <div className="invalid-feedback">
                {validationErrors[field?.name]}
              </div>
            )}
          </div>
        );
      case "radio":
        return (
          <div key={field?.name} className={`mt-3 mb-3`}>
            <div className="radiocontainer">
              <label>{field?.label}</label>

              {field?.options.map((option) => (
                <div key={option.value} className="form-check">
                  <input
                    type="radio"
                    name={field?.name}
                    value={option?.value}
                    checked={formData[field?.name] === option.value}
                    onChange={(e) =>
                      handleChange(field.name, e.target.value, "radio")
                    }
                    className="form-check-input"
                  />
                  <label className="form-check-label">{option.label}</label>
                </div>
              ))}
            </div>
            {validationErrors[field.name] && (
              <div className="invalid-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="row filters-row-inputStyles">
      {/* <div className="dynamicform-parent"> */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "9px",
          padding: "10px",
          flexWrap: "wrap",
        }}
      >
        {formConfig?.map((field) => (
          <div key={field?.name} className={`${field.gridClass}`}>
            {(showParentDesignation || field?.isVisible !== false) &&
              renderField(field)}
            {/* {renderField(field)} */}
          </div>
        ))}
        <div className="fltr-btns-container">
          <button
            className="flte-btn"
            style={{ padding: "14px 24px", borderRadius: "38px" }}
            onClick={handleSearch}
          >
            Search
          </button>
          <button
            className="clear-btn"
            style={{ padding: "14px 24px", borderRadius: "38px" }}
            onClick={handleClear}
          >
            Clear
          </button>
        </div>
      </div>
      {/* </div> */}
    </div>
  );
};

export default ListLogisticsFilters;
